import { takeEvery } from 'redux-saga';
import { put } from 'redux-saga/effects';

export function* init() {
    yield put({ type: 'product:teeup' }); /* trigger for cordial */
}

export function* root() {
    yield* [
        takeEvery('cosmic-profile:init', init),
    ];
}



// WEBPACK FOOTER //
// ./app/sagas/cosmic-profile.js